export default __webpack_public_path__ + "static/media/nigel_williams.4721180e.jpg";